import { render, staticRenderFns } from "./loader.component.vue?vue&type=template&id=5792663f&"
import script from "./loader.component.vue?vue&type=script&lang=js&"
export * from "./loader.component.vue?vue&type=script&lang=js&"
import style0 from "./loader.component.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports